import React from 'react';
import { Card, Table } from 'antd';
import { getAccountsToVerify } from './actions';

class Verification extends React.Component{

	props:{
		/**
		 * @property type - The type of verification to show. Dist or Documents
		 */
		type: string
	}



	render(){

		const columns = [
			{ title:"" }
		]

		return (
			<Card
				title={ `Verify ${this.props.type}` }>

				<Table 
					columns={columns}
					dataSource={this.state.users} />


			</Card>
		)
	}

	componentWillMount(){
		getAccountsToVerify(this.props.type)
			.then( res => this.setState({
				users: res.data.users
			}))
	}

	componentWillReceiveProps(nextProps){
		if(nextProps.type !== this.props.type){
			getAccountsToVerify(nextProps.type)
				.then( res => this.setState({
					users: res.data.users
				}))
		}
	}

	


}

export default Verification;


// WEBPACK FOOTER //
// ./src/components/verification/index.js